'use strict';

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

require('es6-promise');

require('isomorphic-fetch');

var queryString = _interopDefault(require('query-string'));

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * 重载Error对象 code异常对应错误码 message:
 * @param code
 * @param message
 * @private
 */


var KZError = function (_Error) {
  _inherits(KZError, _Error);

  function KZError() {
    var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _classCallCheck(this, KZError);

    var _this = _possibleConstructorReturn(this, (KZError.__proto__ || Object.getPrototypeOf(KZError)).call(this, message));

    _this.code = code;
    return _this;
  }

  return KZError;
}(Error);

var KZError_1 = KZError;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var TIMEOUT_IN_MS = 5000;
var allowedMethods = ['GET', 'POST', 'DELETE', 'PUT'];
var methodsWithBody = ['POST', 'PUT'];
var requestService = {
  loadedPool: {},
  waitingPool: {}
};

var headers2Object = function headers2Object(headers) {
  if (!(headers instanceof Headers)) {
    throw new KZError_1(1, 'headers must be instanceof Headers');
  }

  var obj = {};

  if (typeof headers.keys === 'function') {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = headers.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;
        obj[key] = headers.get(key);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else {
    obj = _extends({}, headers);
  }

  return obj;
};

var processResponse = function processResponse(res) {
  // @see https://fetch.spec.whatwg.org/#concept-internal-response
  if (res.type === 'opaqueredirect') {
    throw new KZError_1(6, 'redirect found');
  }

  if (res.status > 500) {
    throw new KZError_1(3, 'request failed');
  }

  var response = {
    status: res.status,
    headers: headers2Object(res.headers),
    body: null
  };
  var contentType = res.headers.get('content-type');
  var resType = contentType ? contentType.split('/')[1].split(';')[0] : null;

  try {
    switch (resType) {
      case 'json':
        return res.json().then(function (json) {
          response.body = json;
          return response;
        });

      case 'html':
      case 'plain':
        return res.text().then(function (data) {
          response.body = data;
          return response;
        });

      default:
        return res.json().then(function (json) {
          response.body = json;
          return response;
        });
    }
  } catch (e) {
    throw new KZError_1(4, 'data format error');
  }
};

var timeoutFetch = function timeoutFetch(ms, promise) {
  return new Promise(function (resolve, reject) {
    var timer = setTimeout(function () {
      reject(new KZError_1(5, 'fetch time out'));
    }, ms);
    promise.then(function (res) {
      clearTimeout(timer);
      resolve(res);
    }, function (err) {
      clearTimeout(timer);
      reject(err);
    });
  });
};

var lazyFetch = function lazyFetch(uri, fetchOption) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise(function (resolve, reject) {
    var key = uri;
    var pool = requestService.waitingPool[key];

    if (!requestService.loadedPool[key]) {
      if (!pool || pool.length === 0) {
        requestService.waitingPool[key] = [];
        pool = requestService.waitingPool[key];
      }

      pool.push(function (err, result) {
        if (err) return reject(err);
        return resolve(result);
      });
      requestService.loadedPool[key] = true;
      return timeoutFetch(options.timeout, fetch(uri, fetchOption)).then(processResponse).then(function (res) {
        var callback = pool.shift();

        while (callback) {
          callback(null, res);
          callback = pool.shift();
        }

        requestService.loadedPool[key] = false;
      }).catch(function (error) {
        var callback = pool.shift();

        while (callback) {
          callback(error);
          callback = pool.shift();
        }

        requestService.loadedPool[key] = false;
      });
    }

    return pool.push(function (err, result) {
      if (err) return reject(err);
      return resolve(result);
    });
  });
};

var request = function request(_ref) {
  var url = _ref.url,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? 'GET' : _ref$method,
      _ref$headers = _ref.headers,
      headers = _ref$headers === undefined ? {} : _ref$headers,
      _ref$data = _ref.data,
      data = _ref$data === undefined ? '' : _ref$data,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === undefined ? TIMEOUT_IN_MS : _ref$timeout,
      _ref$redirect = _ref.redirect,
      redirect = _ref$redirect === undefined ? 'manual' : _ref$redirect;
  method = method.toUpperCase();

  if (allowedMethods.indexOf(method) === -1) {
    throw new KZError_1(2, 'request method ' + method + ' is not allowed');
  }

  var fetchOption = {
    headers: headers,
    redirect: redirect,
    credentials: 'include',
    method: method
  };

  if (methodsWithBody.indexOf(method) > -1) {
    fetchOption.body = data;
  }

  if (method === 'GET') {
    return lazyFetch(url, fetchOption, {
      timeout: timeout
    });
  }

  return timeoutFetch(timeout, fetch(url, fetchOption)).then(processResponse);
};

var request_1 = request;

var parseName = function parseName(name) {
  var parts = name.split('/');
  var groupName = parts.length === 1 ? 'default' : parts[0];
  var apiName = parts.length === 1 ? name : parts[1];
  return {
    groupName: groupName,
    apiName: apiName
  };
};

var defaultResponseProcessor = function defaultResponseProcessor(res) {
  return res;
};

var defaultRequestProcessor = function defaultRequestProcessor(req) {
  return req;
};

var isBrowser = typeof window !== 'undefined';

var hasHost = function hasHost(url) {
  var reg = /^(https?:)?\/\//i;
  return reg.test(url);
};

var utils = Object.freeze({
  parseName: parseName,
  defaultResponseProcessor: defaultResponseProcessor,
  defaultRequestProcessor: defaultRequestProcessor,
  isBrowser: isBrowser,
  hasHost: hasHost
});
/**
 * 类型检查
 */

var getType = Object.prototype.toString;
var type = {
  isObject: function isObject(o) {
    return getType.call(o) === '[object Object]';
  },
  isArray: function isArray(o) {
    return getType.call(o) === '[object Array]';
  },
  isNull: function isNull(o) {
    return getType.call(o) === '[object Null]';
  },
  isString: function isString(o) {
    return getType.call(o) === '[object String]';
  },
  isNumber: function isNumber(o) {
    return getType.call(o) === '[object Number]';
  },
  isUndefined: function isUndefined(o) {
    return getType.call(o) === '[object Undefined]';
  }
};
var type_1 = type;
/**
 *
 * @param oStr {{example: 'http://www.kuaizhan.com/add/:id/test'}}
 * @param opt
 */
// const trim = require('./trim');

var tplPattern = /\/:[\w\b]+/g;

var replaceUrlTemplate = function replaceUrlTemplate(urlPath) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!type_1.isString(urlPath)) {
    throw new KZError_1(1, 'function replaceTemplate`s 1th argument must be a String');
  }

  if (!type_1.isObject(params)) {
    throw new KZError_1(1, 'function replaceTemplate`s 2th argument must be a Object');
  }

  return urlPath.replace(tplPattern, function (s) {
    var name = s.trim().replace('/:', '');
    var value = new String(params[name]);

    if (type_1.isUndefined(value)) {
      throw new KZError_1(1, oStr + ' need params ' + prev + ', but got undefined');
    } else {
      return '/' + value.trim();
    }
  });
};

var replaceUrlTemplate_1 = replaceUrlTemplate;

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
} // const parse = require('url-parse');


var parseName$1 = utils.parseName,
    defaultRequestProcessor$1 = utils.defaultRequestProcessor,
    defaultResponseProcessor$1 = utils.defaultResponseProcessor,
    isBrowser$1 = utils.isBrowser,
    hasHost$1 = utils.hasHost;
/*
 * groups结构
 * {
 *      groupExample: {
 *          settings: {
 *              // settings go here
 *              urlPreifix: '',
 *              requestProcessor: req => req,
 *              responseProcessor: res => res,
 *              timeout: 5s,
 *          },
 *          apis: {
 *              // apis go here
 *              apiExample: {
 *                  method: 'get',
 *                  url: '/example/list',
 *                  headers: {},
 *              },
 *          },
 *      },
 * }
 * */

/* resolve params 结构
 * {
 *  ****************************
 *   //if only data config then
 *       //data goes here
 *  *********** or *************
 *     data: {
 *         // qs, params and body
 *         // data goes here
 *     },
 *     headers: {
 *         // headers configs
 *     },
 *     method: 'get',
 *  ****************************
 * } */

var Ds = function () {
  function Ds(opts) {
    _classCallCheck$1(this, Ds);

    this.groups = {};
  }

  _createClass(Ds, [{
    key: 'registerGroup',
    value: function registerGroup(groupName) {
      var groupSetting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.groups[groupName]) {
        throw new KZError_1(1, 'groupName ' + groupName + ' has already been declared');
      }

      this.groups[groupName] = {
        settings: groupSetting,
        apis: {}
      };
    }
  }, {
    key: 'register',
    value: function register(name, config) {
      var _parseName = parseName$1(name),
          groupName = _parseName.groupName,
          apiName = _parseName.apiName;

      this.ensureGroupName(groupName);
      this.checkApiNameConfict(groupName, apiName);
      this.checkApiConfig(config);
      this.groups[groupName].apis[apiName] = config;
    }
  }, {
    key: 'resolve',
    value: function resolve(name) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _parseName2 = parseName$1(name),
          groupName = _parseName2.groupName,
          apiName = _parseName2.apiName;

      this.checkApiExist(groupName, apiName);
      var _groups$groupName$set = this.groups[groupName].settings,
          _groups$groupName$set2 = _groups$groupName$set.urlPrefix,
          urlPrefix = _groups$groupName$set2 === undefined ? '' : _groups$groupName$set2,
          _groups$groupName$set3 = _groups$groupName$set.responseProcessor,
          responseProcessor = _groups$groupName$set3 === undefined ? defaultResponseProcessor$1 : _groups$groupName$set3,
          _groups$groupName$set4 = _groups$groupName$set.requestProcessor,
          requestProcessor = _groups$groupName$set4 === undefined ? defaultRequestProcessor$1 : _groups$groupName$set4,
          timeout = _groups$groupName$set.timeout;
      var _groups$groupName$api = this.groups[groupName].apis[apiName],
          url = _groups$groupName$api.url,
          method = _groups$groupName$api.method,
          headers = _groups$groupName$api.headers;
      var payloadObj = this.handlePayload(payload, method, requestProcessor);
      var apiUrl = this.makeApiUrl(url, payloadObj, urlPrefix);

      var apiHeaders = _extends$1({}, headers, payloadObj.headers);

      var finalParams = {
        url: apiUrl,
        method: method,
        data: payloadObj.body,
        headers: apiHeaders,
        timeout: payload.timeout || timeout
      };
      return request_1(finalParams).then(responseProcessor);
    }
  }, {
    key: 'resolveAll',
    value: function resolveAll(reqs) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var sum = reqs.length;
        var results = [];
        var count = 0;
        reqs.map(function (req, index) {
          var payload = {
            params: req.params,
            query: req.query,
            queryType: req.queryType,
            body: req.body,
            headers: req.headers
          };

          _this.resolve(req.name, payload).then(function (res) {
            results[index] = _extends$1({}, res);
            count += 1; //若全部请求已返回则执行resolve

            if (count === sum) {
              resolve(results);
            }
          }).catch(reject);
        });
      });
    }
  }, {
    key: 'request',
    value: function request(opts) {
      var url = this.makeApiUrl(opts.url, opts);
      return request_1(_extends$1({}, opts, {
        url: url
      }));
    }
  }, {
    key: 'jsonp',
    value: function jsonp() {}
  }, {
    key: 'ensureGroupName',
    value: function ensureGroupName(groupName) {
      if (!this.groups[groupName]) {
        this.groups[groupName] = {
          settings: {},
          apis: {}
        };
      }
    }
  }, {
    key: 'checkApiNameConfict',
    value: function checkApiNameConfict(groupName, apiName) {
      if (this.groups[groupName].apis[apiName]) {
        throw new KZError_1(1, apiName + ' in ' + groupName + ' has already been declared');
      }
    }
  }, {
    key: 'checkApiExist',
    value: function checkApiExist(groupName, apiName) {
      if (!this.groups[groupName].apis[apiName]) {
        throw new KZError_1(1, apiName + ' in ' + groupName + ' has not been declared');
      }
    }
  }, {
    key: 'checkApiConfig',
    value: function checkApiConfig(config) {}
  }, {
    key: 'makeApiUrl',
    value: function makeApiUrl(url, payloadObj) {
      var urlPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var qs = '';
      var replacedUrl = url;

      if (payloadObj.params) {
        replacedUrl = replaceUrlTemplate_1(url, payloadObj.params);
      }

      var queryType = payloadObj.queryType;

      if (payloadObj.query && Object.keys(payloadObj.query).length > 0) {
        if (queryType === 'bracket') {
          qs = '?' + queryString.stringify(payloadObj.query, {
            arrayFormat: 'bracket'
          });
        } else {
          qs = Object.keys(payloadObj.query).reduce(function (prev, cur) {
            return prev = '' + prev + (prev === '?' ? '' : '&') + cur + '=' + payloadObj.query[cur];
          }, '?');
        }
      }

      var connectedUrl = '' + urlPrefix + replacedUrl + qs;

      if (!isBrowser$1 && !hasHost$1(connectedUrl)) {
        return 'http://127.0.0.1:80' + urlPrefix + replacedUrl + qs;
      } else return connectedUrl;
    }
  }, {
    key: 'handlePayload',
    value: function handlePayload(payload, method, requestProcessor) {
      if (payload.query || payload.body || payload.params) {
        return requestProcessor(payload);
      }

      var newPayload = {};

      if (Object.keys(payload).length > 0) {
        if (method === 'GET' || 'DELETE') {
          newPayload.query = payload;
        } else {
          newPayload.body = payload;
        }
      }

      return requestProcessor(newPayload);
    }
  }]);

  return Ds;
}();

var Ds_1 = Ds;

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var dsInstance = new Ds_1();

var ds = function ds(opts) {
  return dsInstance.request(opts);
};

ds.create = function (opts) {
  return new Ds_1(opts);
};

ds.get = function (opts) {
  return dsInstance.request(_extends$2({
    method: 'GET'
  }, opts));
};

ds.post = function (opts) {
  return dsInstance.request(_extends$2({
    method: 'POST'
  }, opts));
};

ds.put = function (opts) {
  return dsInstance.request(_extends$2({
    method: 'PUT'
  }, opts));
};

ds.delete = function (opts) {
  return dsInstance.request(_extends$2({
    method: 'DELETE'
  }, opts));
};

ds.jsonp = function (opts) {
  return dsInstance.request(_extends$2({
    method: 'jsonp'
  }, opts));
};

var main = ds;
module.exports = main;